import { API, graphqlOperation } from "aws-amplify";
import { getInboundShipment } from "../../../graphql/inbound/custom-queries";
import { logError } from "../../../utils/appUtils";

export const fetchInventoryEditInbound = async ({
  record,
  setInbound,
  notify,
}) => {
  try {
    const response = await API.graphql(
      graphqlOperation(getInboundShipment, { id: record.inboundShipmentId }),
    );
    setInbound(response?.data?.getInboundShipment);
  } catch (err) {
    logError("InventoryEdit:getInboundData", err, notify);
  }
};
